import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatMenuTrigger, MatDialog } from '@angular/material';
import { TestedIndividualService } from 'src/app/services/tested-individual.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms'
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { PolicyService } from '../../services/policy.service'
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-add-candidate-modal',
  templateUrl: './add-candidate-modal.component.html',
  styleUrls: ['./add-candidate-modal.component.scss']
})
export class AddCandidateModalComponent implements OnInit {
  loading: boolean;
  passwordMismatch: boolean;
  candidateForm
  error: string;
  errorFromserver: string;
  jobId: any;
  show: boolean;
  pwd: boolean;
  isEdit
  isPolicy: boolean
  systemDate = new Date();

  show1: boolean;
  pwd1: boolean;
  @ViewChild('clickMenuTrigger', { static: false })
  private readonly clickMenuTrigger: MatMenuTrigger;


  constructor(public dialogRef: MatDialogRef<any>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public formBuilder: FormBuilder, public _policyService: PolicyService,
    public _testedIndividualService: TestedIndividualService, public activatedRoute: ActivatedRoute, public _EncryptDecryptService: EncryptDecryptService) { }

  ngOnInit() {
    this.jobId = this.data.mpjob


    console.log('Modal Data In Add Candidate:', this.data);

    $("#password").click(function () {
      $("#password").toggleClass("fa-eye fa-eye-slash");
    });

    $("#cpassword").click(function () {
      $("#cpassword").toggleClass("fa-eye fa-eye-slash");
    });

    let size = Object.keys(this.data).length;
    console.log("hello Here is the size===>", size)
    if (this.data && this.data.isEdit == true) {
      this.data.password = this._EncryptDecryptService.decrypt(this.data.password)
      this.data.confirmPassword = this.data.password;
      console.log("Hello Edit Client data ", this.data)
      this.isEdit = true
    } else {
      console.log("Hello Add Client DAta", this.data)
      this.isEdit = false
    }
    this.createForm(this.data)
  }

  validate(data) {
    console.log("Validating ", data);
    if (!data.name) return { valid: false, field: "Name" };
    if (!data.email) return { valid: false, field: "Email" };
    if (data.password !== data.confirmPassword) {
      this.passwordMismatch = true;
      return false
      // return { valid: false, field: "Password Missmatch" };
    }
    this.passwordMismatch = false;
    return true
  }

  createForm(editData?) {

    this.candidateForm = this.formBuilder.group({
      name: new FormControl((editData && editData.name) ? editData.name : '', Validators.required),
      email: new FormControl((editData && editData.email) ? editData.email : '', Validators.required),
      password: new FormControl((editData && editData.password) ? editData.password : 'Platinum1!', Validators.required),
      confirmPassword: new FormControl((editData && editData.confirmPassword) ? editData.confirmPassword : 'Platinum1!', Validators.required),
      // password: new FormControl((editData && editData.password) ? editData.password : '', Validators.compose([
      //   Validators.required,
      //   this._policyService.patternValidator(/\d/, { hasNumber: true }),
      //   this._policyService.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
      //   Validators.minLength(8)
      // ])),
      // confirmPassword: new FormControl((editData && editData.confirmPassword) ? editData.confirmPassword : '', Validators.required),
      // }, {
      //   validator: this._policyService.passwordMatchValidator
    })

  }



  doSubmit() {
    this.error = ""
    this.errorFromserver = ""
    console.log("Submit ", this.data);
    console.log("Validating = ", this.validate(this.data));
    if (!this.validate(this.data)) {
      console.log("RETURNING");
      return;
    }

    console.log("this.candidateForm.value ===>  ", this.candidateForm.value);
    if (this.isEdit) {
      let user = this.candidateForm.value
      user['password'] = this._EncryptDecryptService.encrypt(this.candidateForm.value.password)
      user['confirmPassword'] = this._EncryptDecryptService.encrypt(this.candidateForm.value.confirmPassword)
      user['mpJob'] = this.jobId
      user['isPolicy'] = this.isPolicy
      user['_id'] = this.data.userId
      this.loading = true;

      this._testedIndividualService.editCandidate(user).subscribe(data => {
        this.data = data;
        this.loading = false;
        this.closoeDialog({
          action: 'edit',
          result: 'success',
          data: this.data
        });
        // this.dialogRef.close(data);


      }, err => {
        this.loading = false;
        // this.errorFromserver = err.msg
      });
    }
    else {
      let user = this.candidateForm.value
      user['password'] = this._EncryptDecryptService.encrypt(this.candidateForm.value.password)
      user['confirmPassword'] = this._EncryptDecryptService.encrypt(this.candidateForm.value.confirmPassword)
      user['mpJob'] = this.jobId

      // Do Submit
      this.loading = true;

      this._testedIndividualService.addCandidate(user).subscribe(data => {
        this.data = data;
        this.loading = false;
        this.dialogRef.close(data);

      }, err => {
        this.loading = false;
        this.errorFromserver = err.msg
      });
    }
  }

  delete() {
    this.openDialog(DeleteConfirmModalComponent, "Candidate").subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        this.loading = true;
        this._testedIndividualService.deleteTestedIndividual(this.data.userId).subscribe(res => {
          this.loading = false;
          this.closoeDialog({
            action: 'delete',
            result: 'success',
            data: this.data
          });
        }, err => {
          this.loading = false;
          this.closoeDialog({
            action: 'delete',
            result: 'err',
            data: err
          });
        });
      }
    })
  }



  password() {
    this.show = !this.show;
    this.pwd = !this.pwd;
  }

  onKeyPress(x) {
    // x.preventDefault();  
    this.isPolicy = true
    this.clickMenuTrigger.openMenu();
  }
  closeModel(x) {
    this.clickMenuTrigger.closeMenu();
  }

  cpassword() {
    this.show1 = !this.show1;
    this.pwd1 = !this.pwd1
  }


  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }
  closoeDialog(result) {
    this.dialogRef.close(result);
  }


}
